import { takeLatest, call, all, put } from "redux-saga/effects";
import { AnyAction } from "redux";
import {
  deleteCampaigns,
  onCreateCampaign,
  getTenCampaignsService,
  getCount,
  submitMetricInformationService,
} from "service/campaign.service";
import { ICampaign } from "common/interfaces/campaign.interface";
import { IAPIError } from "common/interfaces/api.interface";
import { uploadAssetsService } from "service/upload.service";
import { IImageAsset } from "common/interfaces/file.interface";
import * as campaignActions from "../actions/campaign.actions";
import * as constants from "../constants/campaign.constants";
import * as metricActions from "../actions/metric.actions";
import * as metricsConstants from "../constants/metric.constants";

function* createCampaign(action: AnyAction) {
  try {
    const imageAssetResponse: IImageAsset[] = yield call(uploadAssetsService, [
      action.metadataImage,
    ]);
    const faviconAssetResponse: IImageAsset[] = yield call(
      uploadAssetsService,
      [action.metadataFavicon]
    );
    const response: ICampaign = yield call(
      onCreateCampaign,
      action.templateId,
      action.clientId,
      action.campaignName,
      action.metadataTitle,
      action.metadataDescription,
      imageAssetResponse[0]._id,
      faviconAssetResponse[0]._id
    );
    yield put(campaignActions.onCreateCampaignSucceed(response));
  } catch (err) {
    yield put(campaignActions.onCreateCampaignFailed(err as IAPIError));
  }
}

function* getTenCampaigns(action: AnyAction) {
  try {
    const response: ICampaign[] = yield call(
      getTenCampaignsService,
      action.query,
      action.page
    );
    yield put(campaignActions.getCampaignsSucceed(response));
  } catch (err) {
    yield put(campaignActions.getCampaignsFailed(err as IAPIError));
  }
}

function* getCampaignCount() {
  try {
    const count: number = yield call(getCount);
    yield put(campaignActions.getCampaignCountSucceed(count));
  } catch (err) {
    yield put(campaignActions.getCampaignCountFailed(err as IAPIError));
  }
}

function* onDeleteCampaigns(action: AnyAction) {
  try {
    const response: ICampaign[] = yield call(
      deleteCampaigns,
      action.campaignsId
    );
    yield put(campaignActions.deleteCampaignsSucceed(response));
  } catch (err) {
    yield put(campaignActions.deleteCampaignsFailed(err as IAPIError));
  }
}

function* onSubmitMetricInformation(action: AnyAction) {
  try {
    const assetResponse: IImageAsset[] = yield call(uploadAssetsService, [
      action.image,
    ]);
    yield call(
      submitMetricInformationService,
      action.campaignId,
      action.date,
      action.VTR,
      action.CTR,
      action.openRate,
      assetResponse[0]._id
    );
    yield put(metricActions.onSubmitsMetricInformationSucceed());
  } catch (err) {
    yield put(metricActions.onSubmitsMetricInformationFailed(err as IAPIError));
  }
}

export default all([
  takeLatest(constants.ON_CREATE_CAMPAIGN_REQUESTED, createCampaign),
  takeLatest(constants.ON_RETRIEVE_CAMPAIGNS_REQUESTED, getTenCampaigns),
  takeLatest(constants.ON_DELETE_CAMPAIGNS_REQUESTED, onDeleteCampaigns),
  takeLatest(constants.ON_RETRIEVE_CAMPAIGNS_REQUESTED, getCampaignCount),
  takeLatest(
    metricsConstants.ON_SUBMIT_METRICS_INFORMATION_REQUESTED,
    onSubmitMetricInformation
  ),
]);
